module.exports = __webpack_public_path__ + "img/gal-12.28260e79.jpg";